import { useEffect, useState } from 'react'

import {
  Box,
  Dialog,
  Divider,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemIcon,
  Paper,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core'
import ClearIcon from '@material-ui/icons/Clear'
import CloseIcon from '@material-ui/icons/Close'
// import DescriptionIcon from '@material-ui/icons/Description'
// import DeviceHubIcon from '@material-ui/icons/DeviceHub'
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted'
// import InputIcon from '@material-ui/icons/Input'
// import OpenInNewIcon from '@material-ui/icons/OpenInNew'
// import RecentActorsIcon from '@material-ui/icons/RecentActors'
// import ReplyAllIcon from '@material-ui/icons/ReplyAll'
import SearchIcon from '@material-ui/icons/Search'
// import SmsIcon from '@material-ui/icons/Sms'
// import ABTestIcon from 'components/Icons/ABTestIcon'
// import LogicIcon from 'components/Icons/LogicIcon'
// import MultipleChoiceIcon from 'components/Icons/MultipleChoiceIcon'
// import NluIcon from 'components/Icons/NluIcon'
import { useFlow } from 'contexts/Flow/flowContext'
import {
  MetaBlockType,
  MetadataBlock,
  // DynamicBlockType,
  MetadataBlocks,
} from 'contexts/Flow/types'
import EIntentType from 'enums/EIntentType'
import { DataFlow, DataForm, InputOutputObject, Output } from 'models/DataFlow'
import useTranslator from 'utils/hooks/Translator'
import { useStyles } from './styles'
import './styles.css'
// import HttpIcon from '@material-ui/icons/Http';
import { markSelected } from 'components/Flow/utils/NodeContainer'
import {
  SIMILARITY_ACCURACY_BLOCKS_TYPE,
  SIMILARITY_ACCURACY_DEFAULT,
} from 'constants/blocks'
import AddBlockToFlowController from 'controllers/library/AddBlockToFlowController'
import GetOffsetPositionFlowController from 'controllers/library/GetOffsetPositionFlowController'
import DataFormModel from 'models/DataFormModel'
import { getTranslationKeys } from 'utils/i18n/types'
import data from './metablocks.json'

const environment = process.env.REACT_APP_ENV

export default function ModalOptions(props: { anchorEl: any }) {
  const { state, dispatch, mountNodeContent, goToNodePosition } = useFlow()
  const classes = useStyles()
  const { getTranslation } = useTranslator()
  const [searchTerm, setSearchTerm] = useState<string>('')

  const intentsList = [
    // {
    //   name: getTranslation('intents.sendMessage'),
    //   intentType: EIntentType.SendMessage,
    //   icon: <SmsIcon className={classes.listSvg} />,
    // },
    // {
    //   name: getTranslation('intents.simpleQuestion'),
    //   intentType: EIntentType.SimpleQuestion,
    //   icon: <InputIcon className={classes.listSvg} />,
    // },
    // {
    //   name: getTranslation('intents.optionsBlock'),
    //   intentType: EIntentType.OptionsBlock,
    //   icon: <MultipleChoiceIcon />,
    // },
    // {
    //   name: getTranslation('intents.carousel'),
    //   intentType: EIntentType.Carousel,
    //   icon: <RecentActorsIcon className={classes.listSvg} />,
    // },
    // {
    //   name: getTranslation('intents.sendDocument'),
    //   intentType: EIntentType.SendDocument,
    //   icon: <DescriptionIcon className={classes.listSvg} />,
    // },
    {
      name: getTranslation('intents.nlu'),
      intentType: EIntentType.NLU,
      // icon: <NluIcon />,
    },
    // {
    //   name: getTranslation('intents.logic'),
    //   intentType: EIntentType.Logic,
    //   icon: <LogicIcon size="20" />,
    // },
    {
      name: getTranslation('intents.newGroup'),
      intentType: EIntentType.NewGroup,
      // icon: <ReplyAllIcon className={classes.listSvg} />,
    },
    {
      name: getTranslation('intents.multipleChoice'),
      intentType: EIntentType.MultipleChoiceParent,
      // icon: <DeviceHubIcon className={classes.listSvg} />,
    },
    // {
    //   name: getTranslation('intents.abTest'),
    //   intentType: EIntentType.ABTest,
    //   icon: <ABTestIcon size="20" />,
    // },
    // {
    //   name: getTranslation('intents.toHtml'),
    //   intentType: EIntentType.OpenHTML,
    //   icon: <OpenInNewIcon className={classes.listSvg} />,
    // },
  ]

  const [blocksGroupedByCategory, setBlocksGroupedByCategory] = useState<{
    [category: string]: MetadataBlock[]
  }>({})

  useEffect(() => {
    const grouped = groupBlocksByCategory(data as MetadataBlocks)
    setBlocksGroupedByCategory(grouped)
  }, [])

  // useEffect(() => {
  //   async function fetchMetaBlocks() {
  //     const response = await fetch(
  //       'https://cloud-metablocks.web.fintalk.io/metablocks.json'
  //     );
  //     if (response.ok) {
  //       const metaBlocks = await response.json();
  //       const grouped = groupBlocksByCategory(metaBlocks as MetadataBlocks);
  //       setBlocksGroupedByCategory(grouped);
  //     }
  //   }

  //   fetchMetaBlocks();
  // }, []);

  function groupBlocksByCategory(data: MetadataBlocks): {
    [category: string]: MetadataBlock[]
  } {
    const grouped: { [category: string]: MetadataBlock[] } = {}

    data.blocks.forEach((block) => {
      if (!grouped[block.category]) {
        grouped[block.category] = []
      }

      grouped[block.category].push(block)
    })

    return grouped
  }

  const getBlockName: { [key in MetaBlockType]: string } = {
    ABTest: 'teste-ab',
    Api: 'api',
    Carousel: 'carrossel',
    Entry: 'entrada',
    Question: 'pergunta',
    Message: 'mensagem',
    Multiple: 'multipla',
    Logic: 'logica',
    ToAnotherBlock: 'pular',
    GetDocument: 'documento',
    ValidateCPF: 'valida-cpf',
    ValidateCNPJ: 'valida-cnpj',
    Notification: 'notifica',
    Conditional: 'condicional',
    AI123: '123AI',
    SimpleCarousel: 'carrossel-simples',
    Advanced: 'avançado',
    Bubble: 'bubble',
    StartFollowUp: 'start-follow-up',
    StopFollowUp: 'stop-follow-up',
  }

  function handleCreateIntent(intentType: EIntentType) {
    const payload =
      intentType === EIntentType.MultipleChoiceParent
        ? ''
        : '// #PARSER#CONNECTOR#Saída#\n'
    const xml =
      intentType === EIntentType.MultipleChoiceParent
        ? ''
        : '<xml xmlns="https://developers.google.com/blockly/xml"><block type="connector" id="cAsx5InyFQ]_.i,bM.[~" x="150" y="150"><field name="TEXT">Saída</field></block></xml>'

    const dataForm: DataForm = {
      groupId: state.idGroup || '',
      name: '',
      description: '',
      intentType,
      outputs: [],
      dataBlockly: {
        lastVersion: 1,
        payload,
        xml,
        compiledPayload: '',
      },
      listType: 1,
    }

    dispatch({ type: 'openModalForms', data: { dataForm } })
    dispatch({ type: 'closeModalIntentType' })
  }

  const getDataFormOutputsFromType: { [key in MetaBlockType]: Output[] } = {
    Question: [{ title: 'Sucesso' }, { title: 'Outros' }],
    Message: [{ title: 'Saída' }],
    ABTest: [{ title: 'Saída' }],
    Entry: [{ title: 'Saída' }],
    Advanced: [{ title: 'Saída' }],
    Logic: [{ title: 'Saída' }],
    ToAnotherBlock: [{ title: 'Saída' }],
    GetDocument: [{ title: 'Saída' }],
    Multiple: [{ title: 'Saída' }, { title: 'Outros' }],
    SimpleCarousel: [{ title: 'Saída' }, { title: 'Outros' }],
    Carousel: [{ title: 'Saída' }, { title: 'Outros' }],
    ValidateCPF: [{ title: 'Saída' }],
    Notification: [{ title: 'Saída' }],
    Conditional: [{ title: 'Saída' }],
    ValidateCNPJ: [{ title: 'Saída' }],
    Api: [
      {
        title: 'Sucesso',
        statusCode: '200',
        ifCondition: 'resposta.statusCode == 200',
      },
      {
        title: 'Requisição Ruim',
        statusCode: '400',
        ifCondition: 'resposta.statusCode == 400',
      },
      {
        title: 'Erro Interno',
        statusCode: '500',
        ifCondition: 'resposta.statusCode == 500',
      },
      {
        title: 'Outros',
      },
    ],
    AI123: [{ title: '123AI', nameIntent: 'AI123' }, { title: 'Outros' }],
    Bubble: [],
    StartFollowUp: [{ title: 'Saída' }],
    StopFollowUp: [{ title: 'Saída' }],
  }

  const getOutputsFromType: { [key in MetaBlockType]: InputOutputObject } = {
    Question: {
      output_1: { connections: [] },
      output_2: { connections: [] },
    },
    Message: { output_1: { connections: [] } },
    ABTest: { output_1: { connections: [] } },
    Entry: { output_1: { connections: [] } },
    Advanced: { output_1: { connections: [] } },
    Logic: { output_1: { connections: [] } },
    ToAnotherBlock: {},
    GetDocument: { output_1: { connections: [] } },
    ValidateCPF: { output_1: { connections: [] } },
    Notification: { output_1: { connections: [] } },
    Conditional: { output_1: { connections: [] } },
    ValidateCNPJ: { output_1: { connections: [] } },
    AI123: {
      output_1: { connections: [] },
      output_2: { connections: [] },
    },
    Multiple: {
      output_1: { connections: [] },
      output_2: { connections: [] },
    },
    SimpleCarousel: {
      output_1: { connections: [] },
      output_2: { connections: [] },
    },
    Carousel: {
      output_1: { connections: [] },
      output_2: { connections: [] },
    },
    Api: {
      output_1: { connections: [] },
      output_2: { connections: [] },
      output_3: { connections: [] },
      output_4: { connections: [] },
    },
    Bubble: {},
    StartFollowUp: {
      output_1: { connections: [] },
    },
    StopFollowUp: {
      output_1: { connections: [] },
    },
  }

  const handleSendToFlow = async (block: MetadataBlock) => {
    const { editorFlow } = state
    if (!editorFlow) return

    const offsetPosition = new GetOffsetPositionFlowController(
      editorFlow,
    ).getMiddleCanvasPosition()
    const drawflowCurrent = { ...editorFlow.drawflow }
    const controller = new AddBlockToFlowController(
      drawflowCurrent,
      state.idGroup || '',
      offsetPosition,
    )
    const nextId = controller.getNextNodeId()

    const name = `${getBlockName[block.type]}-${nextId}`
    const data = new DataFormModel({
      metadata: block,
      name,
      description: block.description,
      groupId: state.idGroup || 'principal',
      carouselItems: [],
      sendUser: block.type !== 'Question' ? { message: '' } : undefined,
      inputs:
        (block.usesOutputVar && block.type === 'Question') ||
        block.type === 'Entry'
          ? {
              variables: [
                {
                  name: '',
                  questions: [''],
                  required: false,
                  vartype: '@sys.any',
                  defaultValue: '',
                  isList: false,
                  value: '',
                },
              ],
            }
          : { variables: [], userSentences: [] },
      outputs: getDataFormOutputsFromType[block.type],
      intentType: EIntentType.MetadataBlock,
      block_id: String(nextId),
      dataBlockly: {
        compiledPayload: block.jsCode ? `${block.jsCode}` : '',
        lastVersion: 1,
        payload: block.jsCode ? `${block.jsCode}\n` : '',
        xml: '',
      },
      varValue: block.usesOutputVar ? 'resposta' : undefined,
      similarityAccuracy: SIMILARITY_ACCURACY_BLOCKS_TYPE.includes(block.type)
        ? SIMILARITY_ACCURACY_DEFAULT
        : undefined,
    })

    await controller.addBlock({
      0: {
        class: 'dbclick',
        html: '',
        id: 0,
        name: 'dbclick',
        pos_x: offsetPosition.pos_x,
        pos_y: offsetPosition.pos_y,
        typenode: false,
        data: {
          ...data,
          inputs:
            data.isAwaitUserIput() || block.type === 'Advanced'
              ? {
                  variables: [
                    {
                      name: 'resposta',
                      questions: [''],
                      required: true,
                      vartype: '@sys.any',
                      defaultValue: '',
                      isList: false,
                      value: '$resposta',
                    },
                  ],
                }
              : block.type === 'Entry'
                ? {
                    variables: [],
                    userSentences: [],
                  }
                : undefined,
        },
        outputs: getOutputsFromType[block.type],
        inputs: block.type !== 'Entry' ? { input_1: { connections: [] } } : {},
      },
    })
    const drawflow = controller.getDrawflow()
    editorFlow.clear()
    editorFlow.import(drawflow)
    const dataFlow: DataFlow = drawflow.drawflow.Home.data
    mountNodeContent(dataFlow)
    goToNodePosition(nextId)
    markSelected(nextId.toString())
    handleCancel()
  }

  function handleCancel() {
    dispatch({ type: 'closeModalIntentType' })
  }

  function blockNameTranslated(name: string) {
    const translatedName = getTranslation(
      `intents.${name}` as getTranslationKeys,
    )
    return translatedName.startsWith('intents') ? name : translatedName
  }

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value)
  }

  const handleClearFilter = () => {
    setSearchTerm('')
  }

  const filteredBlocks = (blocks: any[]) => {
    if (!searchTerm) return blocks

    const searchLower = searchTerm.toLowerCase()

    return blocks.filter((block) => {
      if (block.name && block.intentType) {
        const originalName = block.name.toLowerCase()
        const translatedName = blockNameTranslated(block.name).toLowerCase()
        return (
          originalName.includes(searchLower) ||
          translatedName.includes(searchLower)
        )
      }

      if (block.prettyName) {
        const prettyName = block.prettyName.toLowerCase()
        const translatedPrettyName = blockNameTranslated(
          block.prettyName,
        ).toLowerCase()
        return (
          prettyName.includes(searchLower) ||
          translatedPrettyName.includes(searchLower)
        )
      }

      return false
    })
  }

  const renderEmptyState = () => (
    <Box className={classes.emptyStateContainer}>
      <FormatListBulletedIcon className={classes.emptyStateIcon} />
      <Typography variant="h6" className={classes.emptyStateTitle}>
        {getTranslation('noSearchResults')}
      </Typography>
      <Typography variant="body2" className={classes.emptyStateDescription}>
        {getTranslation('noSearchResultsDescription')}
      </Typography>
    </Box>
  )

  const renderAllCategories = () => {
    if (searchTerm) {
      const filteredIntentsList = filteredBlocks(intentsList)
      const hasFilteredIntents = filteredIntentsList.length > 0

      const filteredDefaultBlocks = blocksGroupedByCategory['defaultBlocks']
        ? filteredBlocks(blocksGroupedByCategory['defaultBlocks'])
        : []
      const hasFilteredDefault = filteredDefaultBlocks.length > 0

      const filteredAdvancedBlocks = blocksGroupedByCategory['advancedBlocks']
        ? filteredBlocks(blocksGroupedByCategory['advancedBlocks'])
        : []
      const hasFilteredAdvanced = filteredAdvancedBlocks.length > 0

      const otherCategories = Object.keys(blocksGroupedByCategory).filter(
        (category) => !['defaultBlocks', 'advancedBlocks'].includes(category),
      )

      const hasFilteredOthers = otherCategories.some(
        (category) =>
          filteredBlocks(blocksGroupedByCategory[category]).length > 0,
      )

      if (
        !hasFilteredDefault &&
        !hasFilteredAdvanced &&
        !hasFilteredIntents &&
        !hasFilteredOthers
      ) {
        return renderEmptyState()
      }

      return (
        <List className={classes.itemsList}>
          {hasFilteredDefault && (
            <Box>
              {/* <ListItem className={classes.categoryHeader}>
                <Typography
                  variant="subtitle2"
                  className={classes.categoryHeaderText}
                >
                  {getTranslation('defaultBlocks')}
                </Typography>
              </ListItem> */}
              {filteredDefaultBlocks.map((block, index) => {
                let hideBlock = false
                if (block.hide) hideBlock = true
                if (block.hideOnlyPrd) hideBlock = environment === 'production'

                return (
                  !hideBlock && (
                    <ListItem
                      key={block.id || index}
                      button
                      onClick={() => handleSendToFlow(block)}
                      disabled={block.disabled}
                      className={classes.blockItem}
                    >
                      <ListItemIcon className={classes.listItem}>
                        <Typography>
                          {blockNameTranslated(block.prettyName)}
                        </Typography>
                      </ListItemIcon>
                    </ListItem>
                  )
                )
              })}
            </Box>
          )}

          {hasFilteredAdvanced && (
            <Box>
              {/* <ListItem className={classes.categoryHeader}>
                <Typography
                  variant="subtitle2"
                  className={classes.categoryHeaderText}
                >
                  {getTranslation('advancedBlocks')}
                </Typography>
              </ListItem> */}
              {filteredAdvancedBlocks.map((block, index) => {
                let hideBlock = false
                if (block.hide) hideBlock = true
                if (block.hideOnlyPrd) hideBlock = environment === 'production'

                return (
                  !hideBlock && (
                    <ListItem
                      key={block.id || index}
                      button
                      onClick={() => handleSendToFlow(block)}
                      disabled={block.disabled}
                      className={classes.blockItem}
                    >
                      <ListItemIcon className={classes.listItem}>
                        <Typography>
                          {blockNameTranslated(block.prettyName)}
                        </Typography>
                      </ListItemIcon>
                    </ListItem>
                  )
                )
              })}
            </Box>
          )}

          {hasFilteredIntents && (
            <Box>
              {/* <ListItem className={classes.categoryHeader}>
                <Typography
                  variant="subtitle2"
                  className={classes.categoryHeaderText}
                >
                  {getTranslation('legacyBlocks')}
                </Typography>
              </ListItem> */}
              {filteredIntentsList.map((intent) => (
                <ListItem
                  key={intent.name}
                  button
                  onClick={() => handleCreateIntent(intent.intentType)}
                  className={classes.blockItem}
                >
                  <ListItemIcon className={classes.listItem}>
                    {intent.icon}
                    <Typography>{intent.name}</Typography>
                  </ListItemIcon>
                </ListItem>
              ))}
            </Box>
          )}

          {otherCategories.map((category) => {
            const filteredCategoryBlocks = filteredBlocks(
              blocksGroupedByCategory[category],
            )

            if (filteredCategoryBlocks.length === 0) return null

            return (
              <Box key={category}>
                {/* <ListItem className={classes.categoryHeader}>
                  <Typography
                    variant="subtitle2"
                    className={classes.categoryHeaderText}
                  >
                    {getTranslation(category as getTranslationKeys)}
                  </Typography>
                </ListItem> */}
                {filteredCategoryBlocks.map((block, index) => {
                  let hideBlock = false
                  if (block.hide) hideBlock = true
                  if (block.hideOnlyPrd)
                    hideBlock = environment === 'production'

                  return (
                    !hideBlock && (
                      <ListItem
                        key={block.id || index}
                        button
                        onClick={() => handleSendToFlow(block)}
                        disabled={block.disabled}
                        className={classes.blockItem}
                      >
                        <ListItemIcon className={classes.listItem}>
                          <Typography>
                            {blockNameTranslated(block.prettyName)}
                          </Typography>
                        </ListItemIcon>
                      </ListItem>
                    )
                  )
                })}
              </Box>
            )
          })}
        </List>
      )
    }

    return (
      <List className={classes.itemsList}>
        {Object.keys(blocksGroupedByCategory).includes('defaultBlocks') && (
          <Box>
            {/* <ListItem className={classes.categoryHeader}>
              <Typography
                variant="subtitle2"
                className={classes.categoryHeaderText}
              >
                {getTranslation('defaultBlocks')}
              </Typography>
            </ListItem> */}
            {blocksGroupedByCategory['defaultBlocks'].map((block, index) => {
              let hideBlock = false
              if (block.hide) hideBlock = true
              if (block.hideOnlyPrd) hideBlock = environment === 'production'

              return (
                !hideBlock && (
                  <ListItem
                    key={block.id || index}
                    button
                    onClick={() => handleSendToFlow(block)}
                    disabled={block.disabled}
                    className={classes.blockItem}
                  >
                    <ListItemIcon className={classes.listItem}>
                      <Typography>
                        {blockNameTranslated(block.prettyName)}
                      </Typography>
                    </ListItemIcon>
                  </ListItem>
                )
              )
            })}
          </Box>
        )}

        {Object.keys(blocksGroupedByCategory).includes('advancedBlocks') && (
          <Box>
            {/* <ListItem className={classes.categoryHeader}>
              <Typography
                variant="subtitle2"
                className={classes.categoryHeaderText}
              >
                {getTranslation('advancedBlocks')}
              </Typography>
            </ListItem> */}
            {blocksGroupedByCategory['advancedBlocks'].map((block, index) => {
              let hideBlock = false
              if (block.hide) hideBlock = true
              if (block.hideOnlyPrd) hideBlock = environment === 'production'

              return (
                !hideBlock && (
                  <ListItem
                    key={block.id || index}
                    button
                    onClick={() => handleSendToFlow(block)}
                    disabled={block.disabled}
                    className={classes.blockItem}
                  >
                    <ListItemIcon className={classes.listItem}>
                      <Typography>
                        {blockNameTranslated(block.prettyName)}
                      </Typography>
                    </ListItemIcon>
                  </ListItem>
                )
              )
            })}
          </Box>
        )}

        {/* <ListItem className={classes.categoryHeader}>
          <Typography
            variant="subtitle2"
            className={classes.categoryHeaderText}
          >
            {getTranslation('legacyBlocks')}
          </Typography>
        </ListItem> */}
        {intentsList.map((intent) => (
          <ListItem
            key={intent.name}
            button
            onClick={() => handleCreateIntent(intent.intentType)}
            className={classes.blockItem}
          >
            <ListItemIcon className={classes.listItem}>
              {/* {intent.icon} */}
              <Typography>{intent.name}</Typography>
            </ListItemIcon>
          </ListItem>
        ))}

        {Object.keys(blocksGroupedByCategory)
          .filter(
            (category) =>
              !['defaultBlocks', 'advancedBlocks'].includes(category),
          )
          .map((category) => (
            <Box key={category}>
              <ListItem className={classes.categoryHeader}>
                <Typography
                  variant="subtitle2"
                  className={classes.categoryHeaderText}
                >
                  {getTranslation(category as getTranslationKeys)}
                </Typography>
              </ListItem>
              {blocksGroupedByCategory[category].map((block, index) => {
                let hideBlock = false
                if (block.hide) hideBlock = true
                if (block.hideOnlyPrd) hideBlock = environment === 'production'

                return (
                  !hideBlock && (
                    <ListItem
                      key={block.id || index}
                      button
                      onClick={() => handleSendToFlow(block)}
                      disabled={block.disabled}
                      className={classes.blockItem}
                    >
                      <ListItemIcon className={classes.listItem}>
                        <Typography>
                          {blockNameTranslated(block.prettyName)}
                        </Typography>
                      </ListItemIcon>
                    </ListItem>
                  )
                )
              })}
            </Box>
          ))}
      </List>
    )
  }

  if (!state.openModalIntentType) return null

  return (
    <Dialog
      open={true}
      onClose={handleCancel}
      fullWidth
      maxWidth="md"
      PaperProps={{
        style: {
          background: 'rgb(255, 255, 255)',
          borderRadius: '8px',
          overflow: 'hidden',
          maxHeight: 'calc(100vh - 64px)',
        },
      }}
    >
      <Box className={classes.dialogTitle}>
        <Typography variant="h6">{getTranslation('blockSelection')}</Typography>
        <IconButton onClick={handleCancel} className={classes.closeButton}>
          <CloseIcon />
        </IconButton>
      </Box>

      <Divider />

      <Box className={classes.searchContainer}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder={getTranslation('searchBlocks')}
          value={searchTerm}
          onChange={handleSearchChange}
          size="small"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            endAdornment: searchTerm && (
              <InputAdornment position="end">
                <Tooltip title={getTranslation('clearFilter')} arrow>
                  <IconButton
                    size="small"
                    onClick={handleClearFilter}
                    className={classes.clearButton}
                  >
                    <ClearIcon />
                  </IconButton>
                </Tooltip>
              </InputAdornment>
            ),
          }}
          className={classes.searchField}
        />
      </Box>

      <Paper elevation={0} className={classes.blockList}>
        {renderAllCategories()}
      </Paper>
    </Dialog>
  )
}
